import Page from 'modules/app/components/Page';
import s from '../ProductsByCategory/ProductsByCategory.module.scss';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import ShoppingCart from '../ShoppingCart';
import { useState, useRef, useEffect, useMemo } from 'react';
import useGetAllBrands from 'sdk/hooks/shop/useGetAllBrands';
import ShopTopMenu from 'components/shared/ShopTopMenu';
import BrandFilter from '../ProductsByCategory/BrandFilter';
import BrandCard from './BrandCard';

const AllBrands = () => {
  const { isOpenBasket } = useTypedSelector(state => state.postSlice);
  const { setIsOpenBasket } = useActions();
  const { data: brands } = useGetAllBrands();
  const [showBrandsDropdown, setShowBrandsDropdown] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState('All');

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowBrandsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredProducts = useMemo(() => {
    if (!brands) return [];
    if (selectedBrand === 'All') return brands;

    return brands.filter(brand => {
      return brand.name === selectedBrand;
    });
  }, [brands, selectedBrand]);

  return (
    <div style={{ overflow: 'auto' }}>
      <Page disableOverflow activeLink="/shop">
        <ShopTopMenu 
          title="Brands" 
          onCartClick={setIsOpenBasket} 
          backNavigationPath="/shop" 
        />
        <div className={s.container}>
          <BrandFilter
            selectedBrand={selectedBrand}
            setSelectedBrand={setSelectedBrand}
            showBrandsDropdown={showBrandsDropdown}
            setShowBrandsDropdown={setShowBrandsDropdown}
            brands={brands as Array<{ id: number; name: string }>}
          />
          <div className={s.grid}>
            {filteredProducts?.map(brand => (
              <BrandCard key={brand.id} id={brand.id} logo={brand.logo} name={brand.name} />
            ))}
          </div>
        </div>
      </Page>
      <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket} />
    </div>
  );
};

export default AllBrands;
